import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { TabBarItem } from '@/core/components/base/tab-bar/use-tab-bar-query'

const lessonImpulseTabs = [
  { id: 'overview', titleKey: 'lumia.impulseTabs.overview' },
  { id: 'preparation', titleKey: 'lumia.impulseTabs.preparation' },
  { id: 'flow', titleKey: 'lumia.impulseTabs.flow' },
  { id: 'supportAndLanguage', titleKey: 'lumia.impulseTabs.supportAndLanguage' },
  {
    id: 'evaluationAndReflection',
    titleKey: 'lumia.impulseTabs.evaluationAndReflection',
  },
] as const

export const lessonImpulseTabItems = lessonImpulseTabs

const flowTabId = 'flow'
export const evaluationTabId = 'evaluationAndReflection'

export const useLessonImpulseTabItems = () => {
  const { t } = useI18n()

  return computed<TabBarItem[]>(() =>
    lessonImpulseTabs.map((tab) => ({
      id: tab.id,
      title: t(tab.titleKey),
    })),
  )
}

/** First tab, unless a lesson or its feedback is still running. */
export const defaultLessonImpulseTabId = (
  lesson?: {
    endedAt: string | null
    feedbackStartedAt: string | null
  } | null,
): string | undefined => {
  if (!lesson) return undefined
  if (lesson.feedbackStartedAt) return evaluationTabId
  if (!lesson.endedAt) return flowTabId
  return undefined
}
